module.exports = __webpack_public_path__ + "media/bootstrap-icons/hexagon-half-8f9f44f0.svg";